/**
 * @module app.shared
 */

export function updateMaterializeInputLabel(input: HTMLInputElement, label: HTMLLabelElement): void {
    if(!(input && label)) { return; }
    // the following is copied from the updateTextFields method
    // it is more efficient than updating all the inputs
    if(input.value && input.value.length > 0 || input.autofocus || input.getAttribute("placeholder")) {
        label.classList.add("active");
    }
    else if(input.validity) {
        label.classList.toggle("active", input.validity.badInput === true);
    }
    else {
        label.classList.remove("active");
    }
}
